import React from 'react';
import ReactDOM from 'react-dom';

import './styles/defaults.scss';

import './utils/fonts.ts';

import App from './components/App/App';

ReactDOM.render(<App />, document.getElementById('root'));
